import mongoose, { Model, Schema, model } from "mongoose";
import { INotification } from "../interfaces/notification.interface";


const ObjectId = Schema.Types.ObjectId;

const notificationSchema = new Schema<INotification>(
    {
        from: {
            type: ObjectId,
            ref: "User",
            required: false,
        },
        to: {
            type: ObjectId,
            ref: "User",
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            enum: ["INFO", "WARNING", "ERROR", "SUCCESS"],
            default: "INFO",
        },
        isRead: {
            type: Boolean,
            default: false,
        },
        isDeleted: { type: Boolean, default: false },
        result: {
            type: String,
            enum: ['SUCCESS', 'FAILURE', 'PENDING'],
            required: false,
            default: 'PENDING'
        },
        fullName: { type: String, required: false },
        createdAt: { type: Date, default: Date.now },
        updatedAt: { type: Date, default: Date.now },
        profileImage: { type: ObjectId, ref: 'Attachment' }
    },
    { timestamps: true, versionKey: false }
);

const NotificationModel: Model<INotification> = mongoose.model<INotification>("Notification", notificationSchema);
export default NotificationModel